import {
  billDueDate,
  daysJsFormat as datesFormats,
  daysJsFormat,
  formatCurrency,
  renderBillStatus,
  renderMonthByLetter,
  renderUserName,
  roles,
} from "../../../utils/constants";
import { onlyRoleMapping } from "../../../engine/AuthRoute";
import { Popover, Space, Tag } from "antd";
import { colorPrimary } from "../../../root";
import dayjs from "../../../utils/dayjs";
import React from "react";
import { renderAdress } from "../../../shared/container/Addresses/AddresseItem/AddresseHelpers";
import { useTranslation } from "react-i18next";
import { InfoCircleOutlined } from "@ant-design/icons";
import {
  RenderlastDownload,
  RenderlastSent,
} from "../../../shared/components/BillHeader/Bill.helpers";

export const billsByTypeColumns = ({ type, activeState }) => {
  const { t } = useTranslation();

  const { advancedCols = false } = activeState;

  const columns = [
    {
      title: t("BillsByTypeColumns.internalNumber"),
      key: "bill_number",
      width: 80,
      dataIndex: "bill_number",
      sorter: true,
    },
    {
      title: t("BillsByTypeColumns.month"),
      key: "prestationsRef.month",
      width: 100,
      dataIndex: "prestationsRef",
      render: prestationsRef => renderMonthByLetter(prestationsRef.month),
      sorter: (a, b) => {
        return a.prestationsRef.month - b.prestationsRef.month;
      },
    },
    {
      title: t("BillsByTypeColumns.year"),
      key: "prestationsRef.year",
      width: 80,
      dataIndex: "prestationsRef",
      render: prestationsRef => prestationsRef.year,
      sorter: (a, b) => {
        return a.prestationsRef.year - b.prestationsRef.year;
      },
    },
    {
      title: t("BillsByTypeColumns.reference"),
      key: "reference",
      visible: advancedCols,
      width: 200,
      dataIndex: "reference",
      sorter: (a, b) => {
        return a.reference.localeCompare(b.reference);
      },
    },
    onlyRoleMapping([roles.admin, roles.permanance, roles.institution])
      ? {
          title: t("BillsByTypeColumns.institution"),
          render: (n, record) => n.name,
          key: "institution",
          dataIndex: "institution",
          width: 200,
          sorter: (a, b) => {
            return a.institution.name.localeCompare(b.institution.name);
          },
        }
      : null,
    {
      title: t("BillsByTypeColumns.addresses"),
      width: 300,
      visible: advancedCols,
      render: (prestations, u) => {
        return renderAdress(u.prestationsRef?.billing, false, u.institution);
      },
      dataIndex: "prestations",
      sorter: (a, b) => {
        return a.institution.defaultAddress.description.localeCompare(
          b.institution.defaultAddress.description,
        );
      },
    },
    // {
    //   title: t("BillsByTypeColumns.interprete"),
    //   key: "prestationsRef.interprete",
    //   width: 200,
    //   dataIndex: "prestationsRef.interprete",
    //   render: (u, item) => renderUserName(item?.prestationsRef?.interprete),
    //   sorter: (a, b) => {
    //     return (
    //       a?.prestationsRef?.interprete?._id -
    //       b?.prestationsRef?.interprete?._id
    //     );
    //   },
    // },
    // {
    //   title: t("BillsByTypeColumns.linkedService"),
    //   width: 150,
    //   render: (prestations, record) => {
    //     if (type === "multiple") {
    //       return (
    //         <Tag color={colorPrimary}>
    //           {t("BillsByTypeColumns.groupedServices", {
    //             count: prestations.length,
    //           })}
    //         </Tag>
    //       );
    //     } else {
    //       return prestations.map(s => <Tag color={"grey"}>{s.reference}</Tag>);
    //     }
    //   },
    //   key: "prestationsRef.references",
    //   dataIndex: "prestations",
    //   sorter: (a, b) => {
    //     return a.institution.name.localeCompare(b.institution.name);
    //   },
    // },
    {
      title: t("BillsByTypeColumns.dueDate"),
      width: 200,
      key: "createdAt",
      render: (date, u) => {
        return <span>{billDueDate(u)}</span>;
      },
      dataIndex: "createdAt",
      sorter: (a, b) => {
        const dateA = new Date(billDueDate(a));
        const dateB = new Date(billDueDate(b));

        return dateA - dateB;
      },
    },
    {
      title: t("BillsByTypeColumns.amount"),
      width: 150,
      render: (montant, u) => {
        return <span>{formatCurrency(montant)}</span>;
      },
      dataIndex: "amount",
      key: "amount",
      sorter: (a, b) => {
        return a.amount - b.amount;
      },
    },
    {
      title: t("BillsByTypeColumns.status"),
      width: 150,
      render: (montant, u) => {
        return renderBillStatus(u, t);
      },
      dataIndex: "status",
      key: "status",
      sorter: (a, b) => {
        return a.status.localeCompare(b.status);
      },
    },

    onlyRoleMapping([roles.admin, roles.permanance]) &&
    process.env.CUSTOMER_ID === "oseovs"
      ? {
          visible: advancedCols,
          title: t("BillsByTypeColumns.abacusExport"),
          width: 200,
          key: "exportedDate",
          render: (date, u) => {
            return (
              <span>{date ? dayjs(date).format(daysJsFormat.full) : ""}</span>
            );
          },
          dataIndex: "exportedDate",
          sorter: (a, b) => {
            const dateA = new Date(a.exportedDate);
            const dateB = new Date(b.exportedDate);
            return dateA - dateB;
          },
        }
      : null,
    onlyRoleMapping([roles.admin, roles.permanance, roles.mandant])
      ? {
          visible: advancedCols,
          title: t("BillsByTypeColumns.activeInvoiceEmails"),
          render: (institution, u) => {
            return institution?.users?.map(e => e?.email + " ");
          },
          width: 200,
          dataIndex: "institution",
        }
      : null,

    {
      visible: advancedCols,
      title: t("BillHeader.lastSent"),
      width: 200,
      render: (downloaded, bill) => {
        return <RenderlastSent bill={bill} />;
      },
      dataIndex: "downloaded",
    },
    {
      visible: advancedCols,
      title: t("BillsByTypeColumns.downloads"),
      width: 200,
      render: (downloaded, bill) => {
        return (
          <RenderlastDownload
            bill={bill}
            key={bill._id.toString()}
            loadOnInit={true}
          />
        );
      },
      dataIndex: "downloaded",
    },
  ]
    .filter(e => e !== null)
    .filter(p => {
      if (p.visible === undefined) {
        return true;
      } else {
        return p.visible;
      }
    });

  return columns;
};
